export const month_28days = Array.from({ length: 28 }, (_, index) => {
  const day = (1 + index).toString().padStart(2, '0');
  return { label: day, value: day };
});

export const month_29days = Array.from({ length: 29 }, (_, index) => {
  const day = (1 + index).toString().padStart(2, '0');
  return { label: day, value: day };
});

export const month_30days = Array.from({ length: 30 }, (_, index) => {
  const day = (1 + index).toString().padStart(2, '0');
  return { label: day, value: day };
});

export const month_31days = Array.from({ length: 31 }, (_, index) => {
  const day = (1 + index).toString().padStart(2, '0');
  return { label: day, value: day };
});

export const MONTH_LIST = {
  jalali: [
    { label: 'فروردین', value: '01' },
    { label: 'اردیبهشت', value: '02' },
    { label: 'خرداد', value: '03' },
    { label: 'تیر', value: '04' },
    { label: 'مرداد', value: '05' },
    { label: 'شهریور', value: '06' },
    { label: 'مهر', value: '07' },
    { label: 'آبان', value: '08' },
    { label: 'آذر', value: '09' },
    { label: 'دی', value: '10' },
    { label: 'بهمن', value: '11' },
    { label: 'اسفند', value: '12' },
  ],
  gregorian: [
    { label: 'January', value: '01' },
    { label: 'February', value: '02' },
    { label: 'March', value: '03' },
    { label: 'April', value: '04' },
    { label: 'May', value: '05' },
    { label: 'June', value: '06' },
    { label: 'July', value: '07' },
    { label: 'August', value: '08' },
    { label: 'September', value: '09' },
    { label: 'October', value: '10' },
    { label: 'November', value: '11' },
    { label: 'December', value: '12' },
  ],
};

export const DAYS_LIST_JALALI = {
  1: month_31days,
  2: month_31days,
  3: month_31days,
  4: month_31days,
  5: month_31days,
  6: month_31days,
  7: month_30days,
  8: month_30days,
  9: month_30days,
  10: month_30days,
  11: month_30days,
  12: month_29days,
};

export const DAYS_LIST_JALALI_LEAP_YEAR = {
  1: month_31days,
  2: month_31days,
  3: month_31days,
  4: month_31days,
  5: month_31days,
  6: month_31days,
  7: month_30days,
  8: month_30days,
  9: month_30days,
  10: month_30days,
  11: month_30days,
  12: month_30days,
};

export const DAYS_LIST_GREGORIAN = {
  1: month_31days,
  2: month_28days,
  3: month_31days,
  4: month_30days,
  5: month_31days,
  6: month_30days,
  7: month_31days,
  8: month_31days,
  9: month_30days,
  10: month_31days,
  11: month_30days,
  12: month_31days,
};
export const DAYS_LIST_GREGORIAN_LEAP_YEAR = {
  1: month_31days,
  2: month_29days,
  3: month_31days,
  4: month_30days,
  5: month_31days,
  6: month_30days,
  7: month_31days,
  8: month_31days,
  9: month_30days,
  10: month_31days,
  11: month_30days,
  12: month_31days,
};

//#region Jalali Leap Year
// the formula to find leap years is to devide the year by number 33 and find its remaining value for years 1244 to 1342 if the ramining be one of the [1,5,9,13,17,21,26,30] then it's a leap year and for years between 1343 to 1472 the remaining must be one of [1,5,9,13,17,22,26,30] for a leap year
const laterYears_remaining = [1, 5, 9, 13, 17, 22, 26, 30];
const olderYears_remaining = [1, 5, 9, 13, 17, 21, 26, 30];
export const isLeapYear_Jalali = (year) => {
  const remaining = year % 33;
  let isLeapYear = false;
  if (1244 <= year && year <= 1343) {
    const index = olderYears_remaining.findIndex(
      (value) => value === remaining,
    );
    isLeapYear = index === -1 ? false : true;
  } else if (1343 <= year && year <= 1472) {
    const index = laterYears_remaining.findIndex(
      (value) => value === remaining,
    );
    isLeapYear = index === -1 ? false : true;
  }
  return isLeapYear;
};
//#endregion Jalali Leap Year

//#region Gregorian Leap Year
// the formula to find leap years for Gregorian calender is to check divisibility on 4, case true it is leap unless it be divisibale over 100, and 400 case true it is leap as well
export const isLeapYear_Gregorian = (year) => {
  let isLeapYear = false;
  if (year % 400 === 0) {
    isLeapYear = true;
  } else if (year % 4 === 0 && year % 100 !== 0) {
    isLeapYear = true;
  }
  return isLeapYear;
};
//#endregion Gregorian Leap Year
